import { EventsEnum } from '../engine/models/events.enum';
import { HumanInterface } from '../engine/models/human.interface';

export interface RPCEvent<RPCResponse> {
  eventName: EventsEnum;
  aliasEvents?: EventsEnum[];
  mapFn?: (params: any) => RPCResponse;
}

export function defineEvent<RPCResponse>(
  Human: HumanInterface,
  eventName: EventsEnum,
  aliasEvents?: EventsEnum[],
  mapFn?: (params: any) => RPCResponse,
) {
  Human.rpc.defineEvent(eventName, {
    events: aliasEvents || [eventName],
    map: mapFn ? mapFn : (params: any) => <RPCResponse>params,
  });
}
